import { inject } from '@angular/core';
import { createAlreadyOnboardedGuard, createOnboardingGuard, UserQuery, UserService } from '@examdojo/user';
import { isNotNullish } from '@examdojo/util/nullish';
import { of } from 'rxjs';
import { DEFAULT_URL, RootUrlParts } from '../app.model';
// TODO: isUserOnboarded is different based on the app, probably should not be in UserQuery
const isOnboarded = () => inject(UserQuery).isUserOnboarded$;

export const onboardingGuard = createOnboardingGuard({
  isOnboarded,
  onboardingPath: RootUrlParts.Onboarding,
});

export const alreadyOnboardedGuard = createAlreadyOnboardedGuard({
  isOnboarded,
  defaultUrl: DEFAULT_URL,
  onAlreadyOnboarded: () => {
    const userQuery = inject(UserQuery);
    const userService = inject(UserService);
    const user = userQuery.getActive();
    return user && isNotNullish(user.current_onboarding_step)
      ? userService.update(user.id, { current_onboarding_step: null })
      : of(undefined);
  },
});
